import styled from 'styled-components'

export const MainAreaSection = styled.div<{
    colorGuide: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    -webkit-column-break-inside: avoid;
    padding: 24px;
    box-sizing: border-box;
    background-color: ${({ colorGuide }) => (colorGuide ? '#82bef6' : 'none')};
`
